export default ({ selected, id }) => {
  if (!selected.some((sId) => sId === id)) return [...selected, id];
  return [...selected.filter((sId) => sId !== id)];
};
